import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import InvoiceStatusForm from '../../../components/forms/InvoiceStatusForm';
import { useInvoiceStatusApi } from '../../../hooks/useInvoiceStatusApi';
import { useNavigate, useParams } from 'react-router-dom';
import { InvoiceStatusDTO } from '../../../services/apiClient';

const InvoiceStatusEdit: React.FC = () => {
  const { getById, edit } = useInvoiceStatusApi();
  const [entityData, setEntityData] = useState<InvoiceStatusDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Invoice Statuses', href: '/admin/invoicestatuses' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching InvoiceStatus data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/invoicestatuses');
    } catch (error) {
      console.error('Error updating InvoiceStatus:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/invoicestatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.InvoiceStatus.Edit'
    >
        {entityData ? (
          <InvoiceStatusForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/invoicestatuses')}
            isLoading={isSubmitting}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default InvoiceStatusEdit;